



import React, { useEffect } from 'react';
// import './base.min.css';
// import './agreementCss.css';
import './agreementCss.css';
import styles from './agreementCss.css';
import Header from './header.png';
import Logo from './logo.jpg';
import { useLocation } from 'react-router-dom';



const companyAddress = 'VERTEX CARS Unit 5 Waterside drive Langley Slough SL36EZ';

const AgreementHtml = ({

    rental_sign = "",
    rental_name = "",
    renter_name = "",
    postal_code = "",
    license_number = "",
    license_expiry = "",
    address = "",
    phone = "",
    email = "",
    make = "",
    model = "",
    reg_no = "",
    color = "",
    fuel_type = "",
    start_date = "",
    end_date = "",
    rent = "",
    deposit = "",
    renter_sign = "",
    start_time = "",
    end_time = "",
    dob="",

    kinsName = "",
    kinsPhone = "",
    kinsAddress = "",
    kinsEmail = "",
    renterRelation = "",


}) => {

    const location = useLocation();

    



    
    return (
        <div className='body'>

            <div className="container container-2">
                <header className='header' >
                    <img className='img' src={Header} alt="Your Image" />
                </header>
                <div className="content" style={{ display: "flex" }}>
                    {/* <div
                        className="sidebar-2"
                        style={{ position: "absolute", left: 10 }}
                    ></div> */}
                    {/* <div style={{ position: "absolute", left: 10, width: "3%", top: 680 }}>
                        <p
                            className="info-email rotate-class"
                            style={{ top: 10, color: "#467886" }}
                        >
                            info@vertexcars.co.uk
                        </p>
                    </div>
                    <div style={{ position: "absolute", left: 10, width: "3%", top: 500 }}>
                        <p className="info-email rotate-class">0330 133 0153</p>
                    </div> */}
                    <div className="first-page-content-box form-content-2">
                        <img className="logo-img" src={Logo} alt="" />
                        <h3 className='h3' >VEHICLE RENTAL AGREEMENT</h3>
                        <p className='p' style={{ color: "black", fontSize: 9 }}>
                            <b>
                                {" "}
                                1. This Vehicle Rental Agreement (“Agreement”) is made between.
                            </b>{" "}
                        </p>
                        <table className="page-four-table-one">
                            <tbody>
                                <tr>
                                    <td className='td' >Vertex Cars Ltd (Owner) </td>
                                    <td className='td'>
                                        {companyAddress}
                                        {/* Vertex Cars Ltd Company Registration No.11736010 with office at
                                        LANGLEY TRAIN STATION CAR PARK, STATION YARD, SLOUGH SL36ED
                                        (“Owner”){" "} */}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td'>Renter (Full Name)</td>
                                    <td className='td'>
                                        {renter_name}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td'>Address: </td>
                                    <td className='td'>
                                        {address}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td'>Post Code </td>
                                    <td className='td'>
                                        {postal_code}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td'>License Number: </td>
                                    <td className='td'>
                                        {license_number}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td'>License Expiry </td>
                                    <td className='td'>
                                        {license_expiry}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td'>Date Of Birth </td>
                                    <td className='td'>{dob}</td>
                                </tr>
                                <tr>
                                    <td className='td'>Phone Number: </td>
                                    <td className='td'>
                                        {phone}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td'>Email Address: </td>
                                    <td className='td'>
                                        {email}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p className="content-of-figure p" style={{ marginTop: 5 }}>
                            1.1 Owner and Renter are hereinafter collectively referred to as
                            “Parties”.
                        </p>
                        <p className='p' style={{ fontSize: 12 }}>
                            Owner rents to Renter and Renter rents from Owner,subject to the terms
                            and conditions of this Agreement{" "}
                        </p>
                        <p className='p'>
                            <b>1a. Vehicle Details:</b>
                        </p>
                        <table className="page-four-table-one vehicle-detail-table">
                            <tbody>
                                <tr>
                                    <td className='td'>Make</td>
                                    <td className='td'>
                                        {make}
                                    </td>
                                </tr>
                                <tr >
                                    <td className='td'>Model</td>
                                    <td className='td'>
                                        {model}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td'>Vehicle Registration</td>
                                    <td className='td'>
                                        {reg_no}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td'>Color </td>
                                    <td className='td'>
                                        {color}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td'>Fuel Type </td>
                                    <td className='td'>
                                        {fuel_type}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p className='p'>
                            <b>1b. Agreement Commencement Date &amp; Time:</b>{" "}
                        </p>
                        <table className="page-four-table-one">
                            <tbody>
                                <tr>
                                    <td className='td'>Start Date &amp; Time </td>
                                    <td className='td'>
                                        {start_date} {end_time}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td'>End Date &amp; Time</td>
                                    <td className='td'>
                                        {end_date} {end_time}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p className="footer-paragrapgh-page-1 p">
                            {companyAddress}
                        </p>
                    </div>
                </div>
            </div>
            <div className="container">
                <header className='header'>
                    <img className='img' src={Header} alt="Your Image" />
                </header>
                <div className="content" style={{ display: "flex", width: "100%" }}>
                    <div className="sidebar" />
                    <div className="form-content" style={{ width: "93%" }}>
                        <p className="nine-font p">
                            <b>1.b Term.</b> This Agreement shall commence on the day the Renter
                            takes possession of Vehicle and remain in full force and effect until
                            Vehicle is returned to Owner. Renter shall return the Vehicle unless
                            this Agreement is terminated earlier consistent with the terms herein.
                            This agreement is valid for 6 months from the date of commencement of
                            agreement and renter takes possession of the vehicle, if renter wants
                            to continue to keep the vehicle, the agreement will be renewed after
                            every 3 months period. Renter can cancel the agreement with 1 week
                            notice after the 4 weeks from start date.
                        </p>
                        <p className="nine-font p">
                            <b>2. Payment and Security Deposit:</b>
                        </p>
                        <table className="page-two-table-one table">
                            <tbody>
                                <tr>
                                    <td className='td' style={{ fontSize: 12 }}>
                                        <b>Weekly Rent: </b>
                                    </td>
                                    <td className='td' style={{ fontSize: 10, fontWeight: 800 }}>
                                        £{rent}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td' style={{ fontSize: 12 }}>
                                        <b>Security Deposit</b>
                                    </td>
                                    <td className='td' style={{ fontSize: 10, fontWeight: 800 }}>
                                        £{deposit}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p className="point-margin nine-font p">
                            a) Renter shall pay weekly into bank account or cash on due date
                            <b>(amount mentioned in clause 2 of this agreement)</b>. Renter shall
                            also pay other charges in accordance with this Agreement due upon
                            return of Vehicle.
                        </p>
                        <p className="point-margin nine-font p">
                            b) Charges for optional services, if any.
                        </p>
                        <p className="point-margin nine-font p">
                            c) Loss of, or damage or repair to the Vehicle, loss of use,
                            diminution of the Vehicle's value caused by damage to it or repair to
                            it, and costs to enforce such charges including administrative fees
                            for processing the claim and legal expenses.
                        </p>
                        <p className="point-margin nine-font p">
                            d) £ 20 extra charge per day for late return of the Vehicle.
                        </p>
                        <p className="point-margin nine-font p">
                            e) Unless due to the fault of Owner, all fines, penalties, traffic
                            and/or parking violations, court costs, towing charges and other
                            expenses relating to the Vehicle assessed against Owner or the Vehicle
                            during the rental Term.
                        </p>
                        <p className="point-margin nine-font p">
                            f) All expenses Owner incurs due to Renter’s failure to return the
                            Vehicle including costs in locating and recovering the Vehicle.
                        </p>
                        <p className="point-margin nine-font p">
                            g) All costs incurred to collect unpaid monies due.
                        </p>
                        <p className="nine-font p">
                            <b>2.1 Security Deposit.</b> In addition to the fees listed in Section
                            2, Renter shall pay a deposit as mentioned in Clause 2 of this
                            agreement at the time this Agreement is signed. Owner may use the
                            deposit to cover any amounts due under this Agreement.
                        </p>
                        <p className="nine-font p">
                            <b>3. Authorized Drivers.</b> Only those who are a party to this
                            Agreement, sign the Agreement and have a current valid driver’s
                            license to operate the Vehicle are permitted to drive the Vehicle. Any
                            other drivers are prohibited from operating Vehicle.
                        </p>
                        <p className="nine-font p">
                            <b>4. Insurance.</b> Renter is responsible for all loss or damage
                            Renter causes in Vehicle to third parties. Renter must carry insurance
                            satisfactory to Owner. If Owner does not possess such insurance or
                            where law requires, Owner will arrange for automobile insurance to
                            cover Vehicle and Renter. Owner will charge Renter for the insurance
                            provided or It is renter’s responsibility to arrange appropriate
                            insurance, in the event of any accident damage or any other damage to
                            the vehicle Renter is responsible to pay those damages either from his
                            insurer or renter bound to pay. Renter is responsible to have a valid
                            comprehensive insurance of the vehicle throughout the hire period.
                        </p>
                        <p className="nine-font p">
                            <b>5. Restrictions on Use.</b> Renter shall not: a) Permit the Vehicle
                            to be driven by any person who is not an Authorized Driver under this
                            Agreement.
                            <br />
                            b) Operate the Vehicle or permit it to be operated in violation of
                            law, including but not limited to driving under the influence of
                            alcohol or drugs, or in breach of rules and regulations of road
                            traffic.
                        </p>
                        <p className="nine-font p">
                            c) Operate the Vehicle or permit it to be operated to commit a
                            violation of law.
                        </p>
                        <p className="nine-font p">
                            d) Operate the Vehicle or permit it to be operated for any race, test,
                            or contest.
                        </p>
                        <br />
                        <br />
                        <p className="footer-paragrapgh-page-2 p">
                            {companyAddress}
                            
                        </p>
                        <br />
                        <br />
                        <br />
                        <br />
                    </div>
                </div>
            </div>
            <div className="container">
                <header className='header'>
                    <img className='img' src={Header} alt="Your Image" />
                </header>
                <div className="content" style={{ display: "flex" }}>
                    <div className="sidebar" />
                    <div className="form-content" style={{ width: "95%" }}>
                        <p className="nine-font p">
                            e) Operate the Vehicle or permit it to be operated for the transport
                            of more passengers or goods than the maximum allowable for the Vehicle
                            or to carry hazardous or explosive substances of any kind.
                        </p>
                        <p className="nine-font p">
                            f) Drive or permit the Vehicle to be driven by any person who does not
                            hold a current valid driver's license to operate the Vehicle;
                        </p>
                        <p className="nine-font p">
                            g) Drive or permit the Vehicle to be driven or parked on roadways not
                            regularly maintained, or on any roads, beach, driveway, or surface
                            likely to cause damage to the Vehicle.
                        </p>
                        <p className="nine-font p">
                            h) Operate the Vehicle or allow it to be operated to push or tow any
                            other vehicle;
                        </p>
                        <p className="nine-font p">
                            i) allow any person to smoke in the Vehicle.
                        </p>
                        <p className="nine-font p">
                            <b>6. Repair or Loss and Reporting to Police.</b> Vehicle shall not be
                            serviced or repaired, and parts and accessories shall not be replaced
                            without Owner’s prior consent. Renter shall alert Owner to any damage
                            to the Vehicle. Renter shall be responsible for any loss or damage to
                            Vehicle and loss of use, diminution of the Vehicle's value caused by
                            damage to it or repair to it and missing equipment. In the event
                            Renter is in an accident, has an incident in Vehicle or if Vehicle is
                            subject to theft or vandalism Renter shall report the accident or
                            incident to Owner as soon as practicable.
                        </p>
                        <p className="nine-font p">
                            <b>7. Condition of Vehicle.</b> The Condition of Vehicle Checklist
                            (“Checklist”) attached is hereby incorporated by reference. Renter
                            acknowledges that Renter has examined the Vehicle and that it is in
                            good condition except as otherwise specified in the Checklist. OWNER
                            MAKES NO WARRANTY, EXPRESS OR IMPLIED, COURSE OF DEALING, COURSE OF
                            PERFORMANCE AND EXPRESSLY EXCLUDES AND DISCLAIMS ALL WARRANTIES AND
                            REPRESENTATIONS OF ANY KIND, INCLUDING ANY WARRANTIES OF
                            MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE.
                        </p>
                        <p className="nine-font p">
                            <b>8. Return of Vehicle.</b> Renter shall return Vehicle on the date
                            specified in Section 1 in the same condition as Renter received it,
                            except for normal wear and tear. Renter shall return the Vehicle to
                            the agreed return location. If Vehicle is not returned on said date,
                            Owner reserves the right to take any action necessary to regain
                            possession of the Vehicle. Renter is liable to bring the vehicle back
                            to the agreed location on the demand of the owner.
                        </p>
                        <p className="nine-font p">
                            <b>9. Termination.</b> This Agreement shall terminate on the date
                            specified in Section 1. Owner reserves the right to terminate this
                            Agreement earlier upon notice to Renter.
                        </p>
                        <p className="nine-font p" style={{ fontSize: 11 }}>
                            <b>10. Indemnification and Liability.</b> Renter shall indemnify,
                            defend and hold harmless Owner from and against any claim, demand,
                            cause of action, loss or liability (including attorney’s fees and
                            expenses of litigation) for any property damage or personal injury
                            arising from Renter’s use of Vehicle by any cause, , except to the
                            extent caused by Owner’s gross negligence or willful misconduct.{" "}
                            <b>
                                In no event shall Owner be responsible for any indirect, special or
                                consequential loss or damages arising from Renter’s use of Vehicle,
                                including but not limited to loss profits and loss revenue, even if
                                informed of such damages. The provisions of this Article shall
                                survive the termination of this Agreement with respect to any claims
                                or liability accruing before such termination. IN NO EVENT SHALL
                                OWNER BE LIABLE FOR ANY INDIRECT, SPECIAL OR CONSEQUENTIAL LOSS OR
                                DAMAGES ARISING FROM RENTER’S USE OF VEHICLE, INCLUDING BUT NOT
                                LIMITED TO LOSS PROFITS AND LOSS REVENUE, EVEN IF INFORMED OF THE
                                POSSIBILITY OF SUCH DAMAGES.
                            </b>
                        </p>
                        <p className="nine-font p">
                            <b>11. Renter is responsible for the following.</b>
                        </p>
                        <p className="nine-font p" style={{ fontSize: 11 }}>
                            Renter is responsible to pay for any parking charges and any penalty
                            charges on the vehicle during the hire duration.
                            <br />
                            Renter is responsible to pay for any toll or congestion charges &amp;
                            Ultra low Emission Zone charges.
                        </p>
                        <p style={{ color: "black" }} className="nine-font p">
                            <b>12. Ownership.</b> Owner shall always retain ownership and
                            documents for the Vehicle. Renter shall immediately notify Owner in
                            the event Vehicle is levied, has a lien attached or is threatened with
                            seizure. Renter shall indemnify and hold Owner harmless against all
                            loss and damages caused by such action.
                        </p>
                        <p className="nine-font p">
                            <b>13. Severability. </b>In the event any provision of this Agreement
                            is held by a court or other tribunal of competent jurisdiction to be
                            unenforceable, that provision will be enforced to the maximum extent
                            permissible under applicable law, and the other provisions of this
                            Agreement will remain in full force and effect. The parties further
                            agree that in the event such provision is an essential part of this
                            Agreement, they will begin negotiations for a suitable replacement
                            provision.
                        </p>
                        <p />
                        <p className="footer-paragrapgh-page-3 p">
                            {companyAddress}
                        </p>
                    </div>
                </div>
            </div>
            <div className="container" style={{ pageBreakAfter: "unset" }}>
                <header className='header'>
                    <img className='img' src={Header} alt="Your Image" />
                </header>
                <div className="content" style={{ display: "flex" }}>
                    <div className="sidebar" />
                    <div className="form-content" style={{ width: "95%" }}>
                        <p className="nine-font p">
                            <b>14. Entire Agreement.</b> This Agreement represents the entire
                            understanding relating to the subject matter hereof and prevails over
                            any prior or contemporaneous, conflicting, or additional
                            communications. This Agreement can only be modified by a written
                            amendment signed by the party against whom enforcement of such
                            modification is sought.
                        </p>
                        <p className="nine-font p">
                            <b>15. Assignment.</b> Renter may not, without the prior written
                            consent of Owner, transfer or assign this Agreement or any part
                            thereof. Any attempt to do so shall be a material default of this
                            Agreement and shall be void. Renter acknowledges receipt of a copy of
                            this Agreement and acknowledges having read and understood the terms
                            and conditions.
                        </p>
                        <p className="nine-font p">
                            <b>16:Signatures:</b>
                        </p>
                        <table className="page-four-table-one table">
                            <tbody>
                                <tr>
                                    <td className="nine-font td">
                                        Cars Lt On Behalf of Vertex Cars Ltd (owner):
                                    </td>
                                    <td className="nine-font td ">
                                        Renter: {renter_name}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="nine-font td">
                                        Full Name: {rental_name}
                                    </td>
                                    <td className="nine-font td">
                                        Full Name: {renter_name}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="nine-font td">Signature:
                                        {rental_sign &&
                                            <img style={{ width: '50px',marginLeft:10 }} src={rental_sign} />
                                        }
                                    </td>
                                    <td id="userSignature" class="nine-font td">
                                        Signature: {renter_sign &&
                                            <img style={{ width: '50px' }} src={renter_sign} />
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td className="nine-font td">Date: {new Date().toLocaleDateString()} </td>
                                    <td className="nine-font td">Date: {new Date().toLocaleDateString()}  </td>
                                </tr>
                            </tbody>
                        </table>
                        <p className='p' style={{ marginTop: 20 }}>
                            <b>17. Next Of Kin/Reference:</b>
                        </p>
                        <table className="page-four-table-two table">
                            <tbody>
                                <tr>
                                    <td className="nine-font td">Full Name:</td>
                                    <td className="nine-font td">
                                        {kinsName}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="nine-font td">Address: </td>
                                    <td className="nine-font td">
                                        {kinsAddress}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="nine-font td">Phone No: </td>
                                    <td className="nine-font td">
                                        {kinsPhone}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="nine-font td">Email: </td>
                                    <td className="nine-font td">
                                        {kinsEmail}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="nine-font td">Relationship to the renter</td>
                                    <td className="nine-font td">
                                        {renterRelation}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p className="footer-paragrapgh-page-4 p">
                            {companyAddress}
                        </p>
                    </div>
                </div>
            </div>
        </div>



    )

}

export default AgreementHtml